import { IBrand, IBrandRes, ICatalog, ICatalogRes } from '@/interfaces/master';
import * as baseAdapter from './baseAdapter';

export const searchBrands = async () => {
  const ret = await baseAdapter.get<IBrandRes>('/v1/brand/get-brand-list');
  return ret?.data;
};

export const addBrand = async (data: Partial<IBrand>) => {
  const ret = await baseAdapter.post<any>('/v1/brand/add-brand', data);
  return ret?.data;
};

export const updateBrand = async (data: Partial<IBrand>) => {
  const ret = await baseAdapter.put('/v1/brand/update', data);
  return ret?.data;
};

export const matchBrand = async (data: Partial<IBrand>) => {
  const ret = await baseAdapter.put('/v1/brand/match', data);
  return ret?.data;
};

export const searchCatalogs = async () => {
  const ret = await baseAdapter.get<ICatalogRes>('/v1/catalog/gets');
  return ret?.data;
};

export const addCatalog = async (data: Partial<ICatalog>) => {
  const ret = await baseAdapter.post<any>('/v1/catalog/add', data);
  return ret?.data;
};

export const updateCatalog = async (data: Partial<ICatalog>) => {
  const ret = await baseAdapter.put('/v1/catalog/update', data);
  return ret?.data;
};

export const matchCatalog = async (data: Partial<ICatalog>) => {
  const ret = await baseAdapter.put('/v1/catalog/match', data);
  return ret?.data;
};

export const synctoERP = async (data: {
  MASTER_TYPE: 'BRAND' | 'CATALOG' | 'PRODUCT';
}) => {
  const ret = await baseAdapter.post('/v1/master/sync', data);
  return ret?.data;
};
